import { formatDateTime } from '../../utils/format';
import { describeActivityEvent } from './activityEvent';

/**
 * Package activity, newest first. Each row shows a readable summary; the
 * recorded technical payload (hashes, ids, versions) stays one click away.
 */
export function ActivityFeed({ items = [], emptyMessage = 'No activity recorded.' }) {
  if (!items.length) {
    return <p className="text-sm text-eorig-muted">{emptyMessage}</p>;
  }
  return (
    <ol className="relative ml-1 min-w-0 space-y-3 border-l border-eorig-border pl-5">
      {items.map((event) => {
        const { title, summary, details } = describeActivityEvent(event);
        return (
          <li key={event.id} className="relative min-w-0">
            <span
              className="absolute -left-[25px] top-1.5 h-2.5 w-2.5 rounded-full bg-eorig-gradient ring-2 ring-white"
              aria-hidden
            />
            <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-0.5">
              <p className="text-sm font-semibold text-eorig-ink">{title}</p>
              <time className="text-[11px] text-eorig-muted" dateTime={event.created_at}>
                {formatDateTime(event.created_at)}
              </time>
            </div>
            {summary ? (
              <p className="mt-0.5 break-words text-sm leading-snug text-eorig-ink/80">{summary}</p>
            ) : null}
            {details.length ? (
              <details className="mt-1 text-xs">
                <summary className="cursor-pointer select-none text-eorig-muted hover:text-eorig-ink">
                  Technical details
                </summary>
                <dl className="mt-2 grid gap-x-4 gap-y-1.5 rounded-lg bg-eorig-surface px-3 py-2 sm:grid-cols-2">
                  {details.map(([label, value]) => (
                    <div key={label} className="min-w-0">
                      <dt className="text-[10px] font-semibold uppercase tracking-wide text-eorig-muted">
                        {label}
                      </dt>
                      <dd className="break-all font-mono text-[11px] text-eorig-ink">{value}</dd>
                    </div>
                  ))}
                </dl>
              </details>
            ) : null}
          </li>
        );
      })}
    </ol>
  );
}
